import type { FormInstance } from 'antd';

import type { IEditoEventForm } from 'app/typings/edito';

import { EditoContainer } from '../../EditoContainer/EditoContainer';
import { EditoSectionsForm } from '../EditoSectionsForm/EditoSectionsForm';

type Props = {
  form: FormInstance<IEditoEventForm>;
};

export const EditoEndingBlock = ({ form }: Props) => {
  return (
    <EditoContainer
      title="Ending Block"
      subTitle="Can be used to redirect the user to a search or another page"
      sectionOptional
    >
      <EditoSectionsForm
        fieldName="endingBlock"
        form={form}
        type="endingBlock"
      />
    </EditoContainer>
  );
};
